<template>
  <div class="v-file">
    <button @click="clickFileInput" class="v-file__button btn btn--white" :disabled="limitReached">{{loc('addFiles')}}</button>
    <input ref="fileInput" :disabled="limitReached" class="v-file__file-input" type="file" :multiple="!!multiple" v-on:change="onFileChange">
    <div v-if="readFiles.length" class="v-file__files">
      <h4 class="v-file__files-title">{{loc('addedFiles')}}</h4>
      <table class="table">
        <tr v-for="(file, index) in readFiles" v-bind:key="index">
          <td>{{file.name}}</td>
          <td class="table__td is-align-right"><button class="btn btn--white v-file__remove-button" @click="removeFile(index)">{{loc('removeFile')}}</button></td>
        </tr>
      </table>
    </div>
  </div>

</template>

<script>
export default {
  name: 'VFile',
  data: function () {
    return {
      readFiles: []
    }
  },
  props: ['multiple', 'on-change', 'file-count-limit'],
  computed: {
    limitReached() {
      return this.fileCountLimit ? this.fileCountLimit <= this.readFiles.length : false;
    }
  },
  methods: {
    removeFile(index) {
      this.readFiles.splice(index, 1);
      this.onChange(this.readFiles);
    },
    clickFileInput() {
      this.$refs.fileInput.click();
    },
    // If you update this function, remember to update it to Stage app-core rules too
    isDataUrl(dataUrl) {
      const regex = /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*)*$/i;
      return !!dataUrl.trim().match(regex);
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files || [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();

        reader.addEventListener('load', () => {
          if(!this.limitReached && this.isDataUrl(reader.result)) {
            this.readFiles.push({
              data: reader.result,
              file: file,
              name: file.name,
              size: file.size,
              type: file.type
            });

            if(typeof this.onChange === 'function') {
              this.onChange(this.readFiles);
            }
          }
        }, false);

        reader.readAsDataURL(file);
      }
    }
  }
}
</script>

<style>

</style>
